<template>
<div class="loadingio-spinner-eclipse-5jbit0jryb6"><div class="ldio-lggj764ha7">
  <div></div>
</div></div>
</template>

<script>
export default {
  name: 'LoadingSpinner'
}
</script>

<style type="text/css">
  @keyframes ldio-lggj764ha7 {
    0% { transform: rotate(0deg) }
    50% { transform: rotate(180deg) }
    100% { transform: rotate(360deg) }
  }
  .ldio-lggj764ha7 div {
    position: absolute;
    animation: ldio-lggj764ha7 1s linear infinite;
    width: 80px;
    height: 80px;
    top: 10px;
    left: 10px;
    border-radius: 50%;
    box-shadow: 0 2px 0 0 #ffffff;
    transform-origin: 40px 41px;
  }
  .loadingio-spinner-eclipse-5jbit0jryb6 {
    width: 100px;
    height: 100px;
    display: inline-block;
    overflow: hidden;
    background: none;
  }
  .ldio-lggj764ha7 {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
  }
  .ldio-lggj764ha7 div { box-sizing: content-box; }
  /* generated by https://loading.io/ */
</style>